<template>
  <div class="container">
    <div class="vue ">
      <div class="login_container flex">
        <div class="login_bgimage">
          <el-image
            class="image"
            :src="
              require('@/assets/image/backgroundViews/login_images/kuang.png')
            "
          ></el-image>
        </div>
        <div class="login_font flex">
          <div class="font-left"></div>
          <div class="font-right flex">
            <div class="font-logo ">
              <el-image
                class="image"
                :src="require('@/assets/image/public/logo.png')"
              ></el-image>
            </div>
            <div class="font-from">
              <el-input
                class="input"
                v-model="loginFrom.tel"
                placeholder="请输入账号"
              ></el-input>
              <el-input
                class="input"
                v-model="loginFrom.password"
                show-password
                placeholder="请输入密码"
              ></el-input>
              <el-button :loading="lading" @click="loginBut">登录</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 导入我们的api接口
import { apiLogin } from '@/api/backgroundViews' // 导入我们的api接口
export default {
  name: '',
  props: [''],
  data() {
    return {
      lading: false,
      loginFrom: {
        tel: '',
        password: '',
        code: ''
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {},

  methods: {
    // 登录
    loginBut() {
      this.lading = true
      if (localStorage.getItem('Token')) {
        console.log('有 token')
        localStorage.removeItem('Token') // 移除所有的缓存数据
      } else {
        console.log('没有 token')
      }
      apiLogin({
        tel: this.loginFrom.tel,
        password: this.loginFrom.password
      }).then(res => {
        this.lading = false
        if (res.status === '0') {
          this.$Ms('登录成功！')
          // 存储登录成功后的Token
          localStorage.setItem('Token', res.data)
          this.$router.push({
            path: '/NavMenu'
          })
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.flex {
  display: flex;
}
.container {
  height: 100vh;
  max-height: 700px;
  background: url('~@/assets/image/backgroundViews/login_images/loginBg.png')
    no-repeat fixed center;
  background-size: cover;
  .vue {
    padding: 80px 160px;
    width: 100vw;
    height: 100vh;
    .login_container {
      position: relative;
      width: 100%;
      height: 100%;
      .login_bgimage {
        .image {
          margin: 0 auto;
        }
      }
      .login_font {
        position: absolute;
        width: 100%;
        .font-left,
        .font-right {
          width: 50vw;
          text-align: center;
        }
        .font-right {
          justify-content: center;
          flex-wrap: wrap;
          top: 0;
          padding-top: 80px;
          .font-logo {
            .image {
              width: 100%;
              height: 50px;
            }
          }
          .font-from {
            width: 100%;
            // position: absolute;
            padding-top: 8vh;
            .input {
              width: 80%;
              height: 60px;
              margin: 10px 0;
              margin-bottom: 10px;
              /deep/ input {
                height: 64px;
              }
              /deep/ input:focus {
                border-color: #2bb19d;
              }
              /deep/ .el-input-group__append {
                background-color: #fff;
                border-radius: 0;
                cursor: pointer;
              }

              /deep/ .verify {
                font-weight: 600;
                color: #2bb19d;
                font-size: 18px;
              }
            }
            .inputBorder {
              /deep/ input {
                border-right-color: #fff;
              }
            }
            .el-button {
              margin-top: 20px;
              width: 80%;
              height: 70px;
              background-color: #009586;
              color: #fff;
              font-size: 1.5rem;
              font-weight: 800;
            }
          }
        }
      }
    }
  }
}
</style>
